import React, { useState } from "react";
import { toast } from "react-toastify";

import { FilePond, File, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";

import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileEncode,
  FilePondPluginFileValidateSize
);

function ImageSelected({ notifyFileUpload }) {
  const [files, setFiles] = useState([]);
  const checkMimeType = (type) => {
    const types = ["image/png", "image/jpeg"];
    return types.indexOf(type) >= 0;
  };

  const handleSelectFile = (files) => {
    if (files.length === 0) {
      setFiles([]);
      if (typeof notifyFileUpload === "function") {
        notifyFileUpload(files);
      }
      return;
    }
    const { file } = files.find((x) => x) || { file: null };
    if (file) {
      if (checkMimeType(file.type)) {
        if (typeof notifyFileUpload === "function") {
          notifyFileUpload(files);
        }
      } else {
        toast.error("กรุณาเลือก fils นามสกุล (JPEG  PNG)");
      }
    }
  };

  //console.log(files);

  return (
    <div className="App">
      <FilePond
        files={files}
        labelIdle="อัพโหลดรูปภาพ"
        maxFileSize="2MB"
        maxFiles="1"
        labelMaxFileSize="ขนาด file เกิน  1 MB"
        imagePreviewHeight="200"
        imageResizeTargetWidth="200"
        imageResizeTargetHeight="200"
        imageResizeMode="cover"
        allowFileEncode="true"
        acceptedFileTypes={["image/png", "image/jpeg"]}
        styleLoadIndicatorPosition="center bottom"
        styleButtonRemoveItemPosition="center bottom"
        onupdatefiles={(fileItems) => handleSelectFile(fileItems)}
      />
    </div>
  );
}
export default ImageSelected;
